import { API } from "../../../utils";

export const getTandaListAPi = async (query, pagination) => {
  const { pageIndex, pageSize } = pagination;
  let url = `tanda-config?page=${pageIndex}&per_page=${pageSize}`;
  const res = await API.get(url, query);
  return res.data;
};

export const getTandaDetailsApi = async (storeId) => {
  const res = await API.get(`tanda-config-details/${storeId}`);
  return res.data;
};

export const updateTandaConnectionApi = async (payload) => {
  const res = await API.post(`getTandaUrl`, payload);
  return res.data;
};

export const getTandaVerifiedApi = async (payload) => {
  const res = await API.post(`getTandaVerified`, payload);
  return res.data;
};

export const disconnectTandaApi = async (payload) => {
  const res = await API.post(`disconnectTanda`, payload);
  return res.data;
};

export const getTandaSyncHistoryApi = async (params, pagination) => {
  const { pageIndex, pageSize } = pagination;
  let url = `tanda-sync-history?page=${pageIndex}&per_page=${pageSize}`;
  const res = await API.post(url, null, params);
  return res.data;
};

export const tandaSyncByDate = async (payload) => {
  const res = await API.post(`tanda-sync`, payload);
  return res.data;
};

export const getTandaDataStreamsApi = async (payload) => {
  const res = await API.post(`tanda-datastreams`, payload);
  return res.data;
};

export const selectTandaDataStreamApi = async (payload) => {
  const res = await API.post(`tanda-datastream-select`, payload);
  return res.data;
};
